import React, { useEffect, useRef, useState } from 'react';
import './startupservices.css';
import mvp from '../../images/mvp.png';
import personimg1 from '../../images/Ellipse 1226 (1).png';
import personimg2 from '../../images/Ellipse 1226.png';
import techimg1 from '../../images/techtalentimg1.png';
import techimg2 from '../../images/techtalentimg2.png';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

function Startupservices({ defaultTab = 1 }) {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);

    const [toogle, setToogle] = useState(defaultTab);
    const tabRef = useRef([]);
    const [indicatorStyle, setIndicatorStyle] = useState({});

    const toogleTab = (index) => {
        setToogle(index);
    };

    const handleNext = () => {
        setToogle((prev) => (prev === 3 ? 1 : prev + 1)); // Cycle to the next tab
    };

    const handlePrevious = () => {
        setToogle((prev) => (prev === 1 ? 3 : prev - 1)); // Cycle to the previous tab
    };

    useEffect(() => {
        // Update tab indicator position and width based on the active tab
        if (tabRef.current[toogle]) {
            const activeTabElement = tabRef.current[toogle];
            setIndicatorStyle({
                width: `${activeTabElement.offsetWidth}px`,
                left: `${activeTabElement.offsetLeft}px`,
            });
        }
    }, [toogle]);

    return (
        <div className='startupservices' data-aos="fade-up" data-aos-duration="1500">
            <div className="A-title" data-aos="fade-up">
                <span data-aos="fade-up">Services</span>
                <h1 data-aos="fade-up">Explore startup</h1>
                <p data-aos="fade-up" className='title-text'>The key is not just having ideas, but actually taking action to make them happen.</p>
            </div>
            <div className="startupservices-content" data-aos="fade-up" data-aos-duration="2000">
                <div className={toogle === 1 ? 'startupservicesbox startupservicesbox-active' : 'startupservicesbox'}>
                    <img className='startupservicemvp' src={mvp} alt="" />
                </div>
                <div className={toogle === 2 ? 'startupservicesbox startupservicesbox-active' : 'startupservicesbox'}>
                    <div className="agile-team">
                        <div className="person">
                            <img src={personimg1} alt="" />
                            <div className="name-position">
                                <p className='name'>Dato Kalandadze</p>
                                <p className='position'>Mobile App Developer</p>
                            </div>
                            <button>Hire now</button>
                        </div>
                        <div className="person">
                            <img src={personimg1} alt="" />
                            <div className="name-position">
                                <p className='name'>Dato Kalandadze</p>
                                <p className='position'>Mobile App Developer</p>
                            </div>
                            <button>Hire now</button>
                        </div>
                        <div className="person">
                            <img src={personimg1} alt="" />
                            <div className="name-position">
                                <p className='name'>Dato Kalandadze</p>
                                <p className='position'>Mobile App Developer</p>
                            </div>
                            <button>Hire now</button>
                        </div>
                        <div className="person">
                            <img src={personimg1} alt="" />
                            <div className="name-position">
                                <p className='name'>Dato Kalandadze</p>
                                <p className='position'>Mobile App Developer</p>
                            </div>
                            <button>Hire now</button>
                        </div>
                        <div className="person">
                            <img src={personimg1} alt="" />
                            <div className="name-position">
                                <p className='name'>Dato Kalandadze</p>
                                <p className='position'>Mobile App Developer</p>
                            </div>
                            <button>Hire now</button>
                        </div>
                        {/* Other team members */}
                    </div>
                </div>
                <div className={toogle === 3 ? 'startupservicesbox startupservicesbox-active' : 'startupservicesbox'}>
                    <div className="tech-talent">
                        <div className="t-box"></div>
                        <div className="t-box">
                            <img src={techimg1} alt="" />
                            <div className="tbox-name">
                                <h4>Levan Abashidze</h4>
                                <p>AI Specialist</p>
                            </div>
                        </div>
                        <div className="t-box">
                            <img src={techimg2} alt="" />
                            <div className="tbox-name">
                                <h4>Giorgi Merabishvili</h4>
                                <p>DevOps Engineer</p>
                            </div>
                        </div>
                        <div className="t-box"></div>
                    </div>
                </div>
            </div>
            <div className="startupservices-tabs">
                <div
                    className={toogle === 1 ? 'st-tab st-tab-active' : 'st-tab'}
                    onClick={() => toogleTab(1)}
                    ref={(el) => (tabRef.current[1] = el)}
                >
                    <span></span>
                    <h1>MVP</h1>
                    <p>We streamline the development process, ensuring a swift and efficient journey from concept to a market - ready minimum viable product.</p>
                </div>
                <div
                    className={toogle === 2 ? 'st-tab st-tab-active' : 'st-tab'}
                    onClick={() => toogleTab(2)}
                    ref={(el) => (tabRef.current[2] = el)}
                >
                    <span></span>
                    <h1>Agile Team</h1>
                    <p>We streamline the development process, ensuring a swift and efficient journey from concept to a market - ready minimum viable product.</p>
                </div>
                <div
                    className={toogle === 3 ? 'st-tab st-tab-active' : 'st-tab'}
                    onClick={() => toogleTab(3)}
                    ref={(el) => (tabRef.current[3] = el)}
                >
                    <span></span>
                    <h1>Tech Talent</h1>
                    <p>We streamline the development process, ensuring a swift and efficient journey from concept to a market - ready minimum viable product.</p>
                </div>
            </div>
            <div className="stsetvices-buttons">
                <button onClick={handlePrevious}>-</button>
                <button onClick={handleNext}>+</button>
            </div>
        </div>
    );
}

export default Startupservices;
